import {toggleProject} from "./toggleProject";

export function hideProjectMoreDetails(evt) {
    let id = evt.target.closest('.btn-back').dataset.id;

    toggleProject();

    document.querySelector(`.projects .projects__foot [data-id='${id}']`).classList.add('none');
}
